import React from 'react';
import moment from 'moment-timezone';

export default function NewsSnippetItem({newsData,handleListClick,selectedId}) {

    return (
        <div onClick={()=>handleListClick(newsData)} className={`news-snippet-item ${selectedId === newsData?.id ? 'active' : ''}`}>
            <img
                src={newsData?.image_url}
                alt="News"
                className="news-thumbnail"
            />
            <div className="news-snippet-content">
                <div className="news-category">
                    {newsData.category.charAt(0).toUpperCase() + newsData.category.slice(1)}
                </div>
                <h3 className="news-title">
                    {newsData?.title}
                </h3>
                <div className="news-meta ">
                    <div className={"news-chln"}>
                    <span className="news-author-name"><a className={"source_link_section"} href={newsData.source_url}>{newsData.source}</a></span>
                    <span> | </span>
                    <span className="news-date">{moment(newsData?.created_at).fromNow()}</span>
                    </div>
                    <div className="read_more_in_news_button_in_desktop">Read More</div>
                </div>
            </div>
        </div>
    );
}
